import { Maybe, nothing } from 'maybeasy';
import { ResourceFor } from '../../../../../Resourceable';
import { Resource } from '../../../../../Resource/Types';
import { collectionTitleTimeStamp } from '../../ChatbotPreview/Types';

export type AllExperiencesResource = ResourceFor<'/all_experiences', 'get', 200>;
export type ExperienceDetailResource = ResourceFor<'/experience_detail/:id', 'get', 200>;
export type ExperienceResourceArray = AllExperiencesResource['payload']['experiences'];
export type ExperienceResource = ExperienceResourceArray[number];
export type ExperiencePayload = ExperienceResource['payload'];
export interface ClientExperiencePayload extends ExperiencePayload {
  description: Maybe<string>;
  total_weeks: Maybe<number>;
  school_partner_logo_url: Maybe<string>;
}
export type ClientExperienceResource = Resource<ClientExperiencePayload>;
export type ClientExperienceResourceArray = ClientExperienceResource[];
export type LearningCollectionResource = ResourceFor<
  '/new_learning_collection_template',
  'get',
  200
>;
export type ProductCollectionResourceArray =
  LearningCollectionResource['payload']['product_collections'];
export type ProductCollectionResource = ProductCollectionResourceArray[number];
export type ProductCollectionKind = ProductCollectionResource['payload']['kind'];

// System-managed section types (managed by ExecOnline, not user-editable)
export type SystemManagedKind =
  | 'recommendation-engine'
  | 'dynamic-recommendation'
  | 'group-coaching';
export type UserEditableKind = 'learning-design';

export const SYSTEM_MANAGED_KINDS: readonly SystemManagedKind[] = [
  'recommendation-engine',
  'dynamic-recommendation',
  'group-coaching',
] as const;

export const isSystemManaged = (kind: ProductCollectionKind): kind is SystemManagedKind =>
  (SYSTEM_MANAGED_KINDS as readonly string[]).includes(kind);

export type OfferingType = ExperienceResource['payload']['offering_type'];
export type EditLearningCollectionResource = ResourceFor<
  '/learning_collection_template/:id',
  'get',
  200
>;

// Scheduled programs type for date selections
export interface ScheduledProgram {
  id: number; // program_family_id
  program_ids: number[]; // selected program IDs
}

// Extended payload type that includes scheduled_programs (added by backend, not yet in Schema.ts)
export type LearningCollectionPayloadWithScheduledPrograms =
  LearningCollectionResource['payload'] & {
    scheduled_programs?: ScheduledProgram[];
  };

export type LearningCollectionResourceWithScheduledPrograms = {
  payload: LearningCollectionPayloadWithScheduledPrograms;
  links: LearningCollectionResource['links'];
};

export const initialContextState: LearningCollectionResourceWithScheduledPrograms = {
  payload: {
    id: nothing(),
    name: collectionTitleTimeStamp(),
    description: '',
    search: true,
    client_identifier: '',
    product_collections: [],
    updated_at: nothing(),
    internal_name: nothing(),
    published_at: nothing(),
    scheduled_programs: [],
    organization_licenses: [],
    licensed_type_ids: [],
    has_promotables: false,
    browse_all: true,
    has_directly_attached_experiences: false,
  },
  links: [],
};

// todo
export interface TestLearningCollection {
  id: Maybe<number>;
}

export type TestLearningCollectionResource = Resource<TestLearningCollection>;
